import { HistoryItem } from './../../models/history';
import { HttpErrorResponse } from '@angular/common/http';
import { PaymentService } from './../../services/payment.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { getStatus } from 'src/app/util/tools';
import { setUserId } from 'src/app/util/user';
import { Language } from 'src/app/util/lang';
import { faBoxOpen, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {

  public historyItems: HistoryItem[];
  public showModal: boolean = false;
  public showLoading: boolean = false;
  public modalHistoryItem: HistoryItem;
  public getStatus: Function = getStatus;
  public currentLang: string = Language.getCurrentLang();
  public emptyIcon: IconDefinition = faBoxOpen;
  private count: number = 2;

  constructor(private paymentService: PaymentService, private router: Router, private titleService: Title ,  private translate: TranslateService,

  ) { }

  ngOnInit(): void {
    this.getOrdersWithItemsByDeviceUUID();
    this.getTranslations();
  }

  public getTranslations() {
    this.translate.get('Title').subscribe((data) => {
      this.setTitle( data.TitleHistory);
    });
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  public continuePayment(url: string): void {
    window.open(url, '_blank')
  };

  public getReceipt(guid: string): void {
    this.router.navigate([`receipt/${guid}`]);
  };

  public showMoreInfo(modalHistoryItem: HistoryItem): void {
    this.modalHistoryItem = modalHistoryItem;
    this.showModal = true;
  }

  public changeUserId(): void {
    setUserId();
    window.location.reload();
  }

  public updateHistory(): void {
    this.getOrdersWithItemsByDeviceUUID();
  }

  public async getOrdersWithItemsByDeviceUUID(): Promise<void> {
    this.showLoading = true;
    this.paymentService.getOrdersWithItemsByDeviceUUID().subscribe(response => {
      if (response instanceof HttpErrorResponse) {
        // alert('Փորձեք մի փոքր ուշ');
        // this.router.navigate([`notfound`]);
      } else if (!response) {
        if (this.count != 0) {
          this.count--;
          this.getOrdersWithItemsByDeviceUUID();
        };
      } else {
        this.historyItems = response;
      };
      this.showLoading = false;
    });
  }

}
